// extracted by mini-css-extract-plugin
export default {"auth-content":"AuthLayout_auth-content__p+KR3","authContent":"AuthLayout_auth-content__p+KR3","outlet":"AuthLayout_outlet__wJVWl","mobile":"AuthLayout_mobile__lW0pD"};